import type { SVGProps } from 'react';

export const PaperClipIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.8725 4.65086L5.28652 11.2369C5.0955 11.4214 4.94314 11.642 4.83832 11.8861C4.7335 12.1301 4.67833 12.3925 4.67602 12.6581C4.67371 12.9236 4.72432 13.187 4.82488 13.4328C4.92544 13.6786 5.07394 13.9019 5.26173 14.0896C5.44952 14.2774 5.67282 14.4259 5.91861 14.5265C6.16441 14.6271 6.42776 14.6777 6.69332 14.6754C6.95888 14.6731 7.22132 14.6179 7.46533 14.5131C7.70934 14.4082 7.93003 14.2559 8.11452 14.0649L14.5285 7.47886C15.2572 6.72445 15.6603 5.71404 15.6512 4.66525C15.6421 3.61647 15.2214 2.61322 14.4798 1.87159C13.7382 1.12995 12.7349 0.709277 11.6861 0.700163C10.6373 0.69105 9.62693 1.09423 8.87252 1.82286L2.45752 8.40786C1.33221 9.53317 0.700012 11.0594 0.700012 12.6509C0.700012 14.2423 1.33221 15.7685 2.45752 16.8939C3.58283 18.0192 5.10909 18.6514 6.70052 18.6514C8.29195 18.6514 9.81821 18.0192 10.9435 16.8939L17.2005 10.6509"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
